<script setup lang="ts">
import type { IDepositeTypes, IResponseData } from '~/components/widget/select-deposit-type/types'
import type { IProps } from '~/components/entity/deposit'
const props = defineProps<IProps>()
const url = computed(() => useUrlWithParams('/deposit_types', { ...props.queryParams }))
const { data } = useApi<IResponseData<IDepositeTypes[]>>(() => url, {
  key: 'deposit-sidebar-widget'
})
const deposits = computed(() => {
  return data.value?.data.map((i) => {
    return {
      title: i.title,
      url: `/deposits/${i.slug}`,
      icon: i.slug
    }
  })
})
</script>

<template>
  <SidebarBlock
    v-if="deposits"
    :heading-text="$t('widget.select_deposit_type.heading')"
    variant="white"
  >
    <SidebarMenu :menu-items="deposits" />
  </SidebarBlock>
</template>
